// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1F9AE","signatureButtonsRight":"ModalSign_signatureButtonsRight__5EmeV"};